<template>
  <div class="box">
    <table class="table is-fullwidth is-narrow">
      <thead>
        <tr>
          <th>Descripción</th>
          <th>Cantidad</th>
          <th>Valor unitario</th>
          <th>Importe</th>
        </tr>
      </thead>
      <tfoot>
        <tr>
          <th colspan="2" />
          <th>Subtotal</th>
          <th>{{ subTotalCurrency }}</th>
          <th />
        </tr>
        <tr>
          <th colspan="2" />
          <th>Total</th>
          <th>{{ totalCurrency }}</th>
          <th />
        </tr>
      </tfoot>
      <tbody>
        <tr
          v-for="(concept, index) in concepts"
          :key="index"
        >
          <td>
            {{ concept.description }}
          </td>

          <td>
            {{ concept.quantity }}
          </td>

          <td>
            {{ concept.unit | toCurrency(voucherCurrency) }}
          </td>

          <td>
            {{ (concept.unit * concept.quantity) | toCurrency(voucherCurrency) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import {
  mapState,
  mapGetters,
  mapMutations,
  mapActions,
} from 'vuex';

import debounce from 'lodash/debounce';

import { keyUnit } from '@machete/common-catalogs';

export default {
  name: 'PlainConcepts',
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      keyUnitCatalog: keyUnit.map(
        ({ key, value }) => ({
          value: key,
          label: `${key} - ${value}`,
        }),
      ),
      conceptTemplate: {
        productServiceKey: '',
        identificationNumber: '',
        quantity: 0,
        unitKey: '',
        description: '',
        unit: 0,
        amount: 0,
      },
      selected: '',
    };
  },
  computed: {
    ...mapState({
      concepts: state => state.invoice.concepts,
      voucherCurrency: state => state.invoice.voucherCurrency,
      productServiceKeyCatalog: state => state.ui.catalogs.productServiceKey,
    }),
    ...mapGetters({
      totalCurrency: 'invoice/totalCurrency',
      subTotalCurrency: 'invoice/subTotalCurrency',
      ivaCurrency: 'invoice/ivaCurrency',
    }),
    unitKeyObj() {
      // ku = keyUnit iteration
      return (unitKey) => {
        const value = this.keyUnitCatalog.find(ku => ku.value === unitKey);

        if (value) return value.label;

        return '';
      };
    },
    conceptTotal() {
      return ({ unit, quantity }) => {
        const unitParsed = parseFloat(`0${unit}`);
        const quantityParsed = parseInt(`0${quantity}`, 10);

        const total = unitParsed * quantityParsed;

        return total.toLocaleString('es-MX', {
          style: 'currency',
          currency: this.voucherCurrency || 'MXN',
        });
      };
    },
  },
  methods: {
    ...mapMutations({
      setValue: 'invoice/updateConcept',
      addConcept: 'invoice/addConcept',
      deleteConcept: 'invoice/deleteConcept',
    }),
    ...mapActions({
      getCatalog: 'ui/getCatalog',
    }),
    productServiceKeyObj(productServiceKey) {
      const value = this.productServiceKeyCatalog.find(
        psk => psk.value === productServiceKey,
      );

      if (productServiceKey && !value) {
        this.getCatalog({
          catalogName: 'productServiceKey',
          search: productServiceKey,
        });
      }

      if (value) return value.label;

      return '';
    },
    addRow() {
      this.addConcept(this.conceptTemplate);
    },
    deleteRow(index) {
      this.deleteConcept(index);
    },
    onChange(event, index) {
      const { name, value } = event.target;

      const accessor = `concepts.[${index}].${name}`;

      this.setValue({ accessor, value });
    },
    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },
    search: debounce(async (loading, search, vm) => {
      await vm.getCatalog({ catalogName: 'productServiceKey', search });
      loading(false);
    }, 650),
    onChangeSelected(id) {
      this.selected = id;
    },
    onClearSelected() {
      this.selected = '';
    },
  },
};
</script>

<style scoped>
.box {
  overflow-x: auto;
}

.is-rounded {
  padding-left: calc(0.375em - 1px);
  padding-right: calc(0.375em - 1px);
}

.table {
  clear: both;
}

.table > tbody input.input{
  background: white !important;
}

.table > tbody > tr > td > .field {
  max-width: 120px;
}

.table > tbody > tr > td > .field.selected-field {
  max-width: 300px;
  width: 300px;
}

.table > tbody > tr > td > .product-service-key-field,
.table > tbody > tr > td > .product-service-key-field .field {
  width: 240px;
  max-width: 240px;
}

.table > tbody > tr > td > .unit-key-field,
.table > tbody > tr > td > .unit-key-field .field {
  width: 180px;
  max-width: 180px;
}

.table tfoot tr:not(:first-child) th {
  border: 0;
}

.table.is-narrow td {
  padding-bottom: 0.75rem;
}

th,
td {
  vertical-align: middle;
  text-align: center;
}

.actions {
  display: flex;
  justify-content: space-evenly;
}

.action {
  cursor: pointer;
  padding-top: 16px;
}
</style>
